import React from 'react';
import './Footer.css';
import logo from '../../assets/images/footerjio.svg';
const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleContactus = () => {
    window.open('https://forms.cloud.microsoft/r/R2gr83AJiL', '_blank');
    // window.location.href = 'https://forms.cloud.microsoft/r/R2gr83AJiL';
  };

  return (
    <footer className="footer-comp">
      <div className="footer-container1">
        {/* Left Section - Logo and Description */}
        <div className="footer-left">
          <div className="footer-logo">
            <img src={logo} alt="Jio Logo" className="footer-logo-img" />
            <span className="dam-text">DAM</span>
          </div>
          <p className="footer-description">
            Store, manage, and collaborate on assets effortlessly with our intelligent, secure and scalable DAM system.
          </p>
        </div>

        {/* Right Section - Navigation Links */}
        <div className="footer-right">
          <nav className="footer-nav">
            <button onClick={() => scrollToSection('home')} className="footer-link1">Home</button>
            <button onClick={() => scrollToSection('how-it-works')} className="footer-link1">How it Works</button>
            <button onClick={() => scrollToSection('core-capabilities')} className="footer-link1">Core Capabilities</button>
            <button onClick={() => scrollToSection('ai-intelligence')} className="footer-link1">AI Intelligence</button>
            <button onClick={() => scrollToSection('help-faqs')} className="footer-link1">Help & FAQ's</button>
            <button onClick={handleContactus} className="footer-link1">Book a Demo</button>
          </nav>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="footer-bottom">
        <p className="copyright">© Copyright 2025, All Rights Reserved by Jio</p>
      </div>
    </footer>
  );
};

export default Footer;
